import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button} from 'react-bootstrap';
import Modal from '../modal-shim';
import ModalContainer from '../containers/ModalContainer';

export default class Confirmation extends Component {
    static propTypes = {
        name: PropTypes.string.isRequired,
        componentLabel: PropTypes.node,
        cancelLabel: PropTypes.node,
        confirmLabel: PropTypes.node,
        header: PropTypes.node,
        children: PropTypes.node,
        onConfirm: PropTypes.func,
        skipConfirmation: PropTypes.bool,
        component: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    };

    static defaultProps = {
        confirmLabel: 'Ok',
        cancelLabel: 'Cancel',
        header: 'Please confirm',
        component: Button,
    };

    openModal = (e) => {
        if (this.modalContainer) {
            this.modalContainer.getWrappedInstance().openModal(e);
        }
    };

    render() {
        const {name, header, confirmLabel, cancelLabel, componentLabel, children, onConfirm, skipConfirmation, component, ...rest} = this.props;
        if (skipConfirmation) {
            if (!component) {
                return false;
            }
            const Comp = component;
            return <Comp onClick={onConfirm} {...rest}>{componentLabel}</Comp>;
        }

        return (
            <ModalContainer name={name} ref={c => this.modalContainer = c}>{(isOpen, openModal, closeModal) => {
                const modal = (
                    <Modal show={isOpen} onHide={closeModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>{header}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {children}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={closeModal}>{cancelLabel}</Button>
                            <Button bsStyle="danger" onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                closeModal();
                                onConfirm();
                            }}>{confirmLabel}</Button>
                        </Modal.Footer>
                    </Modal>
                );
                if (!component) {
                    return modal;
                }
                const Comp = component;
                return (
                    <Comp onClick={openModal} {...rest}>{componentLabel}
                        {modal}
                    </Comp>
                )
            }}</ModalContainer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Confirmation.js